export enum SnVideoPlayerType {
  HTML5 = 'html5',
  SLDP = 'sldp',
  HLS = 'hls',
  FLV = 'flv',
  WEBSOCKET = 'websocket',
}
